import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#f3e8ff',
      100: '#e9d5ff',
      200: '#d8b4fe',
      300: '#c084fc',
      400: '#a855f7',
      500: '#9333ea',
      600: '#7e22ce',
      700: '#6b21a8',
      800: '#581c87',
      900: '#3b0764',
    },
  },
  styles: {
    global: {
      body: {
        bg: '#0b0720',
        color: '#f8f5ff',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: '12px',
        fontWeight: 'semibold',
      },
      variants: {
        solid: {
          bg: 'linear-gradient(135deg, #a855f7 0%, #ec4899 100%)',
          color: 'white',
          _hover: {
            boxShadow: '0 8px 24px rgba(168,85,247,0.4)',
            transform: 'translateY(-1px)',
          },
        },
      },
    },
    Modal: {
      baseStyle: {
        dialog: {
          borderRadius: '16px',
          bg: 'linear-gradient(180deg, #17103d 0%, #120c30 100%)',
          border: '1px solid rgba(139,92,246,0.3)',
          boxShadow: '0 24px 80px rgba(0,0,0,0.7)',
        },
        header: {
          color: '#f8f5ff',
          borderBottom: '1px solid rgba(139,92,246,0.2)',
        },
        body: { color: '#c4bad8' },
        footer: {
          borderTop: '1px solid rgba(139,92,246,0.2)',
        },
        overlay: {
          backdropFilter: 'blur(6px)',
          bg: 'rgba(5,3,20,0.75)',
        },
      },
    },
    Drawer: {
      baseStyle: {
        dialog: {
          bg: 'linear-gradient(180deg, #0d0730 0%, #080520 100%)',
          borderRight: '1px solid rgba(139,92,246,0.25)',
        },
      },
    },
    Toast: {
      baseStyle: {
        borderRadius: '12px',
        bg: 'linear-gradient(180deg, #17103d, #120c30)',
        color: '#f8f5ff',
        border: '1px solid rgba(139,92,246,0.35)',
      },
    },
  },
});

export default theme;
